import React from 'react';
import './ShopHistory.css';

interface Purchase {
  id: number;
  title: string;
  image_url: string;
  purchase_date: string;
  amount: number; // Valor em Cifras
  status: string;
}

interface ShopHistoryProps {
  purchases: Purchase[];
}

export function ShopHistory({ purchases }: ShopHistoryProps) {
  // Função para formatar o valor como moeda
  const formatAmount = (amount: number) => {
    const amountInReais = amount / 10000; // Converter o valor de Cifras para reais

    // Condicional para formatação
    if (amountInReais >= 1000) {
      return amountInReais.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2, // Exibir 2 casas decimais para valores acima de mil
        maximumFractionDigits: 2,
      });
    } else {
      return amountInReais.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 4, // Exibir 4 casas decimais para valores abaixo de mil
        maximumFractionDigits: 4,
      });
    }
  };

  return (
    <div className="shop-history-container">
      {purchases.map(purchase => (
        <div key={purchase.id} className="shop-history-item">
          {/* Bolinha de status */}
          <div className={`status-bubble status-${purchase.status.toLowerCase()}`}></div>
          
          <img src={purchase.image_url} alt={purchase.title} className="shop-history-image" />
          <div className="shop-history-info">
            <h3>{purchase.title}</h3>
            <p className="price">Preço: {formatAmount(purchase.amount)}</p> {/* Formatando o preço */}
            <p className="purchase-date">Data da compra: {new Date(purchase.purchase_date).toLocaleDateString()}</p>
            <p className="status-text">Status: <span className={`status-${purchase.status.toLowerCase()}`}>{purchase.status}</span></p>
          </div>
        </div>
      ))}
    </div>
  );
}
